export default {
  headline: "Arbeitsunfallmeldung",
  companyAddress: "Name und Anschrift des Unternehmens",
  companyNumber: "Unternehmensnummer beim Unfallversicherungsträger",
  accidentReportReceiver: "Empfänger/-in",
  personSurnameName: "Name, Vorname der versicherten Person",
  personBirthdate: "Geburtsdatum (TT.MM.JJJJ)",
  personStreetNr: "Straße, Hausnummer",
  personZipCode: "Postleitzahl",
  personCity: "Ort",
  personGender: "Geschlecht",
  personNationality: "Staatsangehörigkeit",
  temporaryWorker: "Leiharbeitnehmer/-in",
  trainee: "Auszubildende/-r",
  relationship1: "Die versicherte Person ist",
  relationship2: "mit dem/der Unternehmer/-in",
  continuePaymentWeeks: "Anspruch auf Entgeltfortzahlung besteht für",
  continuePaymentWeeksAddon: "Wochen",
  healthInsurance: "Krankenkasse (Name, PLZ, Ort, bei Familienversicherung Name des Mitglieds)",

  headlineAccident: "Unfalldetails",
  deadlyAccident: "Tödlicher Unfall?",
  accidentDate: "Unfallzeitpunkt (TT.MM.JJJJ)",
  accidentTime: "Unfallzeitpunkt (hh:mm)",
  accidentLocation: "Unfallort (genaue Orts- und Straßenangabe, mit PLZ)",
  accidentHomeoffice: "Unfall im Homeoffice",
  accidentDescription: "Ausführliche Beschreibung des Unfallhergangs (Verlauf, Bezeichnung des Betriebsteils, ggf. Beteiligung von Maschinen, Anlagen, Gefahrstoffen)",
  accidentDescribedBy: "Die Angaben beruhen auf der Schilderung",
  injuredBodyparts: "Verletzte Körperteile",
  injuryType: "Art der Verletzung",
  firstResponder: "Wer hat von dem Unfall zuerst Kenntnis genommen? (Name, Anschrift)",
  firstResponderWitness: "War diese Person Augenzeugin/Augenzeuge des Unfalls?",
  firstTreatmentNameAddress: "Name und Anschrift des behandelnden Arztes",
  workStartEnd: "Beginn und Ende der Arbeitszeit der versicherten Person (hh:mm)",
  workStartEndStart: "von",
  workStartEndEnd: "bis",
  workingAs: "Zum Unfallzeitpunkt beschäftigt/tätig als",
  workingSince: "Seit wann bei dieser Tätigkeit? (TT.MM.JJJJ)",
  workingBranch: "In welchem Teil des Unternehmens ist die versicherte Person ständig tätig?",
  workingStopped: "Hat die versicherte Person die Arbeit eingestellt?",
  workingContinued: "Hat die versicherte Person die Arbeit wieder aufgenommen?",

  date: "Datum",
  phoneNr: "Telefon-Nr. für Rückfragen",
  signature: {
    entrepreneur: "Unterschrift Unternehmer/-in (Bevollmächtigte/-r)",
    entrepreneur_invalid: "Die Unterschrift vom/der Unternehmer-/in fehlt",
    workscommittee: "Unterschrift Betriebsrat (Personalrat)",
    workscommittee_invalid: "Die Unterschrift des Betriebsrats fehlt",
  },
  report_accident: "Arbeitsunfall melden"
}
